import React, { useCallback, useEffect, useMemo, useState } from "react";
import clsx from "clsx";

import * as NotificationUtils from "../../../lib/util/NotificationUtils";
import * as strings from "../../../strings";

import Modal from "../../container/Modal/Modal";
import Text from "../../common/Text/Text";
import { useNotificationVisible } from "../../../lib/hook/NavigationHooks";
import { Translatable } from "lib/util/Translatable";

interface SplashNotificationProps {
	notification: NotificationUtils.PortalNotification;
	heading?: string | Translatable;
	cta?: React.ReactNode;
	className?: string;
}

const SplashNotification: React.FC<SplashNotificationProps> = (props) => {
	const [notificationVisible, setNotificationVisible] = useState(false);
	const [dismissed, setDismissed] = useState(false);

	const visible = useNotificationVisible(
		NotificationUtils.NOTIFICATION_TYPE_SPLASH,
		props.notification.level,
	);

	useEffect(() => {
		setNotificationVisible(visible);
	}, [props.notification, visible]);

	const closeable = useMemo(
		() => props.notification.level !== 1,
		[props.notification],
	);

	const handleClose = useCallback(() => {
		setDismissed(true);
	}, [setDismissed]);

	return (
		<Modal
			className={clsx("SplashNotification", props.className, {
				"-high-level": !closeable,
			})}
			visible={(!dismissed || !closeable) && notificationVisible}
			onVisibleChange={setNotificationVisible}
			onClose={handleClose}
			closeMaskOnClick={closeable}
			closeOnEsc={closeable}
			showCloseButton={closeable}
			padding={true}
			dynamicHeight={true}
		>
			<Text tag={"h1"}>
				{props.heading
					? props.heading
					: props.notification.level === 1
					? strings.SPLASH_NOTIFICATION_LEVEL_1_HEADLINE
					: strings.SPLASH_NOTIFICATION_LEVEL_2_HEADLINE}
			</Text>
			<p
				dangerouslySetInnerHTML={{
					__html: NotificationUtils.cleanNotificationMessage(
						props.notification.message,
					),
				}}
			/>
			{props.cta && (
				<div className={"SplashNotification__cta"}>{props.cta}</div>
			)}
		</Modal>
	);
};

export default SplashNotification;
